import s from './MainScreen.module.css';
import { Menu } from 'components/Menu/Menu';
import { HomeImage } from 'components/HomeImage/HomeImage';
import { Routes, Route } from 'react-router-dom';
import { Voiting } from 'pages/voiting/Voiting/Voiting';
import { Breeds } from 'pages/breeds/Breeds/Breeds';
import { Gallery } from 'pages/gallery/Gallery';
import { BreedsDetail } from 'pages/BreedsDetail/BreedsDetail';
import { Search } from 'pages/search/Search';
import { Favourites } from 'pages/favourites/Favourites';
import { Likes } from 'pages/likes/Likes';
import { Dislikes } from 'pages/gallery/dislikes/Disikes';
import { Modal } from 'pages/modal/Modal';

const MainScreen = () => {
  return (
    <div className={s.menu}>
      <Menu />
      <Routes>
        <Route exact path="/" element={<HomeImage />} />
        <Route path="/voiting" element={<Voiting />} />
        <Route path="/breeds" element={<Breeds />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/breeds/:catId" element={<BreedsDetail />} />
        <Route path="/search" element={<Search />} />
        <Route path="/favourites" element={<Favourites />} />
        <Route path="/likes" element={<Likes />} />
        <Route path="/dislikes" element={<Dislikes />} />
        <Route path="/upload" element={<Modal />} />
      </Routes>
    </div>
  );
};

export { MainScreen };
